import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  name: 'upload',
  type: 'layout',
  active: false,
  data: {
    type: 'image',
    files: [],
    count: 5,
    previewType: 'image',
    label: langValue('Upload File'),
    labelValue: 'Upload File'
  }
}
